export function ResourceLoader(type: string, id: string, url: string) {
  return new Promise((resolve, reject) => {
    const completeId = id + '-' + type
    // Check if element already loaded
    const e = document.getElementById(completeId)
    if(e !== null){
      const a = e.getAttribute('status')
      if(a === 'loaded') {
        resolve()
      } else if (a === 'loading') {
        // Wait for element to load
        // This is just a hack! Implement proper waiting policy
        setTimeout(() => {
          if(e.getAttribute('status') === 'loaded') {
            resolve()
          } else {
            reject()
          }
        }, 500)
      }
    } else {
      // Start loading from remote
      switch (type) {
        case 'css':
          const css = document.createElement('link')
          css.setAttribute('id', completeId)
          css.setAttribute('rel', 'stylesheet')
          css.setAttribute('href', url)
          css.setAttribute('status', 'loading')
          css.onload = () => {
            css.setAttribute('status', 'loaded')
            resolve()
          }
          css.onerror = reject
          document.head.appendChild(css)
          break
        case 'script':
          const script = document.createElement('script')
          script.setAttribute('id', completeId)
          script.setAttribute('src', url)
          script.setAttribute('status', 'loading')
          script.onload = () => {
            script.setAttribute('status', 'loaded')
            resolve()
          }
          script.onerror = reject
          document.head.appendChild(script)
          break
      }
    }
  })
}
